import { GameBaseScenario } from "../scenarios/GameBaseScenario";
import $, { error } from 'jquery'
import { FontSizeMultiplier, GameDataConfig, GameDataManager, SingleScenarioConfig } from "../cvp-webgames-core/Misc/interfaces";
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import { CoreBaseApiBasicResult, CoreBaseApiResult } from "../cvp-webgames-core/Api/CoreBaseApi";
import { TopLeftControlsUIConfig } from "../components/ui/hud/top-left-controls-ui";
import { gameAPI } from "../api/GameAPI";
import Tools from "../cvp-webgames-core/Misc/Tools";

export enum PageType {
	Nothing = 'Nothing',
	MainMenu = 'Main Menu',
	Scenario1 = 'Domiciliary Intake Process Setting',
	Scenario2 = 'Inpatient Mental Health Group Setting',
	Scenario3 = 'Domiciliary Exam Room Racial & Derogatory Slurs',
	Scenario4 = 'Inpatient Veteran Setting',
	Scenario5 = 'P.T.S.D. R.R.T.P. Poor Boundaries'
}


export enum TextHtmlTagType {
    p,
    h1,
    h2
}

let last508WindowId: string = undefined;

export const setLast508WindowId = (id: string): void => {
    last508WindowId = id;
    disableAnyKeyPress();
}

export const updateLast508Window = (): void => {
    if(last508WindowId) {
        setFocus(last508WindowId, () => {
            enableKeyPress();
        });
    } else {
        enableKeyPress();
    }
}

export const enableKeyPress = () => {
    document.onkeydown = (evt) => {
    }
}

export const disableAnyKeyPress = () => {
    document.onkeydown = (evt) => {
        evt.preventDefault();
    }
}

export const parseDynamicHtml = (src: string) => {
    return src.replace('<p class=', `<p class=`)
    .replace('<h1 class=', `<h1 class=`)
    .replace('<h2 class=', `<h2 class=`);
}

class GeneralAudioCaching extends PreCacheItem {
    public audioKeys = {
        beep_short_off_01: 'beep_short_off_01',
        beep_short_on_01: 'beep_short_on_01',
        chime_bell_ding_01: 'chime_bell_ding_01',
        click_04_01: 'click_04_01',
        digi_plink_01: 'digi_plink_01',
        music_marimba_chord_01: 'music_marimba_chord_01'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.beep_short_off_01,
				src: process.env.PUBLIC_URL + '/assets/audio/beep_short_off_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.beep_short_on_01,
				src: process.env.PUBLIC_URL + '/assets/audio/beep_short_on_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.chime_bell_ding_01,
				src: process.env.PUBLIC_URL + '/assets/audio/chime_bell_ding_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.click_04_01,
				src: process.env.PUBLIC_URL + '/assets/audio/click_04_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.digi_plink_01,
				src: process.env.PUBLIC_URL + '/assets/audio/digi_plink_01.mp3'
			},
            {
				type: PrecacheItemType.Audio,
				key: this.audioKeys.music_marimba_chord_01,
				src: process.env.PUBLIC_URL + '/assets/audio/music_marimba_chord_01.mp3'
			}
		];
	}
}

export const generalAudioCaching = new GeneralAudioCaching();

export const updateMentorVideo = (isVisible: boolean, src: string, id: string, onDone?: () => void, overrideTop?: number) => {
    if(!src) {
        throw new Error('src')
    }
    if((window as any)['mentor-internal-forced-update']) {
        (window as any)['mentor-internal-is-visible'] = isVisible;
        (window as any)['mentor-internal-talking-video-src'] = src;
        (window as any)['mentor-internal-talking-video-chapter-id'] = id;
        (window as any)['mentor-internal-override-top'] = overrideTop;
        (window as any)['mentor-internal-onDone'] = () => {
            if(onDone) {
                onDone();
            }
        };
        (window as any)['mentor-internal-forced-update']();
    }
}

export const setVolumeState = (isEnabled: boolean): Promise<boolean> => {
    return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        savedData.data.isAudioEnabled = isEnabled;

        const handleVidMuteState = (mute: boolean) => {
            const vids = document.getElementsByTagName('video');
            for(var indx = 0; indx < vids.length; indx++) {
                vids[indx].muted = true;
            }
            var activeVideo: any = document.getElementsByClassName('active-video-player-video');
            if(activeVideo && activeVideo[0]) {
                activeVideo[0].muted = mute;
            }
            
        }
        if(isEnabled) {
            Tools.getGameManager().SoundManager.unmuteAllSound();
            handleVidMuteState(false);
        } else {
            handleVidMuteState(true);
            Tools.getGameManager().SoundManager.muteAllSound();
        }
        return Tools.saveGame(savedData);
    });
};

export const setClosedCaptionState = (isEnabled: boolean) => {
    return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        savedData.data.isClosedCaptionEnabled = isEnabled;

        return Tools.saveGame(savedData).then(() => {
            if((window as any).forceUpdateInternalCCComp){
                (window as any).forceUpdateInternalCCComp();
            }
        });
    });
};

export const setMotionState = (isEnabled: boolean) => {
    return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        savedData.data.isMotionEnabled = isEnabled;
        (window as any)['core-motion-disabled'] = !isEnabled;
        return Tools.saveGame(savedData).then(() => {
            if((window as any)['core-motion-state']) {
                (window as any)['core-motion-state'](isEnabled);
            }
        
            if(localStorage.getItem('isInAccessibilityScreen-bs') === '1') {
                return;
            }
        
            const iframe:any = document.getElementsByTagName('iframe')[0];
        
            if(iframe) {
                iframe.contentWindow.postMessage(savedData.data.isMotionEnabled ? 'resume' : 'pause')
            }
        
            const vidToStop: HTMLVideoElement = document.querySelector('.main-menu-root video');
        
            if(vidToStop) {
                if(savedData.data.isMotionEnabled) {
                    vidToStop.play();
                } else {
                    vidToStop.pause();
                }
            }
        });
    });
};

export const setAnimationState = (isEnabled: boolean) => {
    return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        savedData.data.isAnimationsEnabled = isEnabled;
        return Tools.saveGame(savedData).then(() => {
            const iframe:any = document.getElementsByTagName('iframe')[0];

            if(iframe) {
                iframe.contentWindow.postMessage(savedData.data.isAnimationsEnabled ? 'resume' : 'pause')
            }

            return true;
        });
    });
};

let partId = 0;
export const getNextPartId = () => {
    return 'Scenario Part ' + (partId++).toString();
}

export const getWindowVariable = (key: string) => {
    return (window as any)[key];
}

export const setFocus = (id: string, onDone?: (success: boolean) => void, timeoutOverride?: number) => {
    setTimeout(() => {
        const el = document.getElementById(id);

        if(el) {
            document.getElementById(id).focus();
            if(onDone) {
                onDone(true);
            }
        } else {
            if(onDone) {
                onDone(false);
            }
        }
    }, typeof timeoutOverride !== 'undefined' ? timeoutOverride : 250);
}


export const setUp508 = (onGetCurrent508WindowLayer: () => {objects: string[]}) => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.which === 9) {
            if((window as any)['disable-508']) {
                e.preventDefault();
                return;
            }
            let current508Layer = onGetCurrent508WindowLayer();

            if(current508Layer.objects.length !== 2) {
                return;
            }

            let lastObj = current508Layer.objects[current508Layer.objects.length - 1]
    
            //508 Window Constraint
            if (e.shiftKey) {
                if (document.activeElement.id === current508Layer.objects[0]) {
                    setFocus(lastObj);
                    e.preventDefault();
                }
            } else {
                // console.log(document.activeElement.id)
                if (document.activeElement.id === lastObj) {
                    setFocus(current508Layer.objects[0]);
                    e.preventDefault();
                }
            }
        }
    });
}

export const updateGlobalTextSize = () => {
    Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        // const body = document.body;
        // body.classList.remove('dynamic-small-text');
        // body.classList.remove('dynamic-default-text');
        // body.classList.remove('dynamic-big-text');

        // const possibleSizes = [];
        // possibleSizes[FontSizeMultiplier.big] = {
        //     p: 'text-lg',
        //     h1: 'text-2xl'
        // };
        // possibleSizes[FontSizeMultiplier.med] = {
        //     p: 'text-md',
        //     h1: 'text-xl'
        // };
        // possibleSizes[FontSizeMultiplier.small] = {
        //     p: 'text-sm',
        //     h1: 'text-lg'
        // };

        // const maxZoomLevel = 200; //maximum zoom level to calculate
        // const maxSize = 2; //maximum to add to font size (if browser zoom level is 100%)
        // let percentage = ((window.devicePixelRatio * 100) / maxZoomLevel);
        // if(percentage > 1) {
        //     percentage = 1;
        // }

        // const dynamicSizeResult = maxSize * percentage;
        // $("p").not(".ignore-dynamic-text").removeClass('text-sm text-md text-lg',).addClass(possibleSizes[savedData.data.fontSizeMultiplier].p);
        // $("h1").not(".ignore-dynamic-text").removeClass('text-lg text-xl text-2xl',).addClass(possibleSizes[savedData.data.fontSizeMultiplier].h1);
    });
}

export const topLeftMenuProps = (scenario: GameBaseScenario, onReturnToMainMenuClicked?: () => void, onForceRefreshEntireUI?: () => void, disableAria?: string, mmColor?: string) => { 
    var result: TopLeftControlsUIConfig = {
        onForceRefreshEntireUI: onForceRefreshEntireUI,
        onAudioToggled: (isEnabled: boolean) => {
            setVolumeState(isEnabled)
        },
        onToggleCC: (isEnabled: boolean) => {
            setClosedCaptionState(isEnabled);
        },
        onTogglePause: (isEnabled: boolean) => {
            setMotionState(isEnabled)
        },
        onReturnToMenuClicked: () => {
            (window as any)['set-508-window-return-to-main-menu-on']();
            if(scenario) {
                scenario.uiWrapper.displayReturnToMainMenu({
                    topId: 'return-to-main-menu-content-top',
                    bottomId: 'return-to-main-menu-content-bottom',
                    onGoToMainMenuClicked: () => {
                        scenario.gameManager.customData.updateWindow(PageType.MainMenu);
                    },
                    onCancelClicked: () => {
                        (window as any)['set-508-window-return-to-main-menu-off']();
                    }
                });
            } else if(onReturnToMainMenuClicked) {
                onReturnToMainMenuClicked();
            }
            
        },
        mmAria: disableAria,
        mmColor: mmColor
    };

    return result
}

export const setVisibilityState = (isEnabled: boolean) => {
    Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        savedData.data.isVisibleFocusEnabled = isEnabled;
        Tools.saveGame(savedData);
    
        const styleTag = isEnabled
              ? $(`
                <style>
                  *:focus, .special-container:focus-within {
                    outline: 3px solid red !important;
                  }
        
                  .super-special-container:focus {
                    border: 3px solid red !important;
                  }
                  </style>
        `)
              : $(`
              <style>
                  *:focus, .special-container:focus-within {
                    border: none !important;
                    outline: none !important;
                  }
                  .super-special-container:focus {
                    border: none !important;
                  }
              </style>
            `);
        $("html > head").append(styleTag);
    });
};

export const updateCurrentScenarioArea = (scenarioIndx: number, currentAreaIndx: number): Promise<boolean> => {
    return Tools.getSaveData().then((savedData: CustomGameDataManager) => {
        savedData.data.scenarios[scenarioIndx].area = currentAreaIndx;
        return Tools.saveGame(savedData);
    });
}

export interface CustomGameDataConfig extends GameDataConfig<CustomGameSingleScenario> {
}

export interface CustomGameSingleScenario extends SingleScenarioConfig {
}

export class CustomGameDataManager extends GameDataManager<CustomGameDataConfig> {
    constructor(public data: CustomGameDataConfig) {
        super(data)
    }
}